
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-investors",
      function () {
        return require("private-next-pages/real-estate-investors.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-investors"])
      });
    }
  